export default __webpack_public_path__ + "static/media/roadmap_path.9bb9cca6.png";